module.exports = __webpack_public_path__ + "static/media/51pic.b10895cd.jpg";